import Vue from 'vue'
import router from './router'
import App from './App.vue'
import store from './store/store'; // Lecture 290

import axios from "axios"; // Lecture 346
import VModal from "vue-js-modal"; // https://www.npmjs.com/package/vue-js-modal

// https://vsupalov.com/avoid-csrf-errors-axios-django/
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

const apiHost = window.location.hostname === 'localhost'
  ? 'http://127.0.0.1:8000'
  : 'https://api.dailytimeline.com';

axios.defaults.baseURL = apiHost + '/';

Vue.use(VModal); // https://www.npmjs.com/package/vue-js-modal

new Vue({
  el: '#app',
  router,
  store, // Lecture 290
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js